<template>
  <v-card flat hover :to="{name:'Products',params:{type:tipo.name_search.toLowerCase()}}">
    <v-layout row align-center>
        <v-flex xs12>
            <v-card-text class="py-1">
                <v-layout row align-center>
                    <v-flex xs2>
                        <v-btn small icon class="handle" v-if="!tipo.highlight && !isDefault">
                            <v-icon color="grey" class="sp-drag">drag_handle</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs2 mr-2>
                        <v-avatar size="32">
                            <img :src="(tipo.image)?uri+tipo.image:uri+tipo.categoria_data.photo">
                        </v-avatar>
                    </v-flex>
                    <v-flex xs8 md6>
                      <span class="subheading pr-1">{{ tipo.name }}</span>
                      <span class="grey--text body-1" v-if="tipo.description != ''">
                          <br>
                          {{ tipo.description }}
                      </span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-flex>
        <v-flex>
            <v-card-actions v-if="!isDefault">
                <v-menu offset-y :open-on-hover="$vuetify.breakpoint.smAndDown">
                    <template v-slot:activator="{ on }">
                        <v-btn small icon v-on="on">
                            <v-icon color="grey">more_vert</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-tile @click="showForm">
                            <v-list-tile-title>
                                Editar
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.stop="delDialog = true" v-if="!tipo.highlight">
                            <v-list-tile-title>
                            Excluir
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-card-actions>
        </v-flex>
        <v-dialog v-model="delDialog" lazy max-width="450px">
            <v-card>
                <v-card-text class="headline">
                    Tem certeza que deseja deletar a categoria <b>{{tipo.name}}</b>? Essa operação irá deletar 
                    também os seus produtos.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-btn
                    color="black"
                    flat
                    @click="delDialog = false"
                    :disabled="loading"
                >
                    Não
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="red"
                    flat
                    @click="removeType"
                    :loading="loading"
                    :disabled="loading"
                >
                    Sim
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
    <v-divider divider class="pa-1"></v-divider>
</v-card>
</template>

<script>
export default {
  props:['tipo'],
  data(){
    return{
      uri:'https://api.socialplace.com.br',
      delDialog:false,
      loading:false
    }
  },
  computed:{
      isDefault(){
          return ['Pendentes','Produtos combo'].indexOf(this.tipo.name) != -1
      }
  },
  methods:{
    showForm(){
        this.$store.commit('FETCH_TYPE',this.tipo)
        this.$store.commit('TOGGLE_TYPE_DIALOG')
    },
    async removeType(){
        this.loading = true
        await this.$store.dispatch('deleteType',this.tipo._id)
        this.loading = false
        this.delDialog = false
    },
    async setType(productType){
        this.$store.state.loading = true
        this.$store.commit('SET_TYPE',productType)
        await this.$store.dispatch('fetchProducts')
        this.$store.state.loading = false
    },
  }
}
</script>

<style>

</style>